export default "__VITE_ASSET__FxE3EtYF__"